import { Injectable } from '@angular/core';
 
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  
userListUrl = `${AppSettings.API_ENDPOINT}/${'get-company-user-list'}`;
userUpdateUrl = `${AppSettings.API_ENDPOINT}/${'edit-user-details'}`;
addUserUrl = `${AppSettings.API_ENDPOINT}/${'add-user-details'}`;
deleteUserUrl = `${AppSettings.API_ENDPOINT}/${'delete-user-details'}`;
deactivateUserUrl = `${AppSettings.API_ENDPOINT}/${'user-activate-deactivate'}`;
changePasswordUrl = `${AppSettings.API_ENDPOINT}/${'change-password-admin'}`;

  constructor(private http: HttpClient) { }

  getUserList(){
    return this.http.get(this.userListUrl);
  }

  updateUser(data:any){
    return this.http.post(this.userUpdateUrl, data);
  }

  addUser(data:any){
    return this.http.post(this.addUserUrl,data);
  }

  deleteUser(id:string){
    return this.http.get(`${this.deleteUserUrl}/${id}`);
  }

  deactivateUser(data:any){
    return this.http.post(this.deactivateUserUrl, data);
  }

  changePassword(data:any){
    return this.http.post(this.changePasswordUrl, data);
  }
}
